import { render, staticRenderFns } from "./WorkerDetailsForm.vue?vue&type=template&id=e659d70e&"
import script from "./WorkerDetailsForm.vue?vue&type=script&lang=js&"
export * from "./WorkerDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports